import { apiService } from "../api";
import { activityApiService } from "../activity-service";

export const getActivities = async (programId: string) => {
const response = await apiService({
    url: `/activity/program/${programId}`,
    method: "get",
    protectedRoute: true,
});
return response
}

export const createActivity = async (payload: any, program_id: string) => {
const response = await apiService({
    url: `/activity/program/${program_id}`,
    method: "post",
    protectedRoute: true,
    requestData: payload,
});
return response; // Usually returns { status, message, data } from your backend
}

export async function deleteActivity(activityId: string) {
const response = await apiService({
    url: `/activity/${activityId}`,
    method: "delete",
    protectedRoute: true,
});
return response;
}

export const getActivity = async (activityId: string) => {
    const response = await apiService({
        url: `/activity/${activityId}`,
        method: "get",
        protectedRoute: true,
    })
    return response
}

export const updateActivity = async (payload: any, program_id: string, actvity_id: string ) => {
    const response = await apiService({
        url: `/activity/program/${program_id}/${actvity_id}`,
        method: "put",
        protectedRoute: true,
        requestData: payload
    })
    return response
}

/**
 * Change activity state (start/stop)
 * PUT /activity/{activity_id}
 */
export const changeActivityState = async (activityId: string, action: "start" | "stop", user: string) => {
    const response = await apiService({
        url: `/activity/state/${activityId}`,
        method: "put",
        protectedRoute: true,
        requestData: {
            action,
            user
        }
    });
    return response;
}

export const getActivityTarget = async (payload: {
    entity_type: string;
    subject_type: string;
    subject_id: string;
}) => {
    const response = await apiService({
        url: `/activity/target`,
        method: "post",
        protectedRoute: true,
        requestData: payload
    })
    return response
}

export const getActivityExport = async (activity_id: string, startDate?: Date, endDate?: Date) => {
    const { getCurrentUserInfo } = await import("@/utils/userInfo");
    const { user_id } = getCurrentUserInfo();

    const headers: Record<string, string> = {
        'user-id': user_id,
    };

    if ((startDate && !endDate) || (!startDate && endDate)) {
        throw new Error("Both startDate and endDate must be provided for date-filtered export.");
    }

    // If dates are provided, use the date-export endpoint with date filters
    if (startDate && endDate) {
        // Format dates to dd/mm/yyyy as required by the backend
        const formatDateToDDMMYYYY = (date: Date): string => {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        };

        return await activityApiService({
            url: `/activity-response/${activity_id}/date-export`,
            method: 'get',
            protectedRoute: true,
            responseType: 'blob',
            params: {
                start_date: formatDateToDDMMYYYY(startDate),
                end_date: formatDateToDDMMYYYY(endDate),
            },
            headers,
        });
    }

    // If no dates provided, use the export endpoint without date filters (exports everything)
    return await activityApiService({
        url: `/activity-response/${activity_id}/export`,
        method: 'get',
        protectedRoute: true,
        responseType: 'blob',
        headers,
    });
}
export const bulkActivityUpdate = async (payload: {
    action: string;
    activity_ids: string[];
}) => {
    return await apiService({
        url: `/activity/state/bulk`,
        method: "put",
        protectedRoute: true,
        requestData: payload
    })
}
